import type * as DailyList from '../types/DailyList'

export default function dailyListComponentParser(
  rawComponent: DailyList.Raw,
): DailyList.Parsed {
  const {
    contentType,
    orderBy,
    qty,
    order,
    noResultsFoundText,
    loadMoreText,
    affiliates,
    courses,
  } = rawComponent.dailyList

  return {
    name: 'DailyList',
    props: {
      contentType,
      orderBy,
      perPage: Number(qty),
      sort: order,
      noResultsFoundText,
      loadMoreText,
      affiliateList: {
        allText: affiliates.allFilterText,
        nearMeText: affiliates.nearMeFilterText,
        headlineText: affiliates.categoryLink.text,
      },
      courseList: {
        allText: courses.allFilterText,
        nearMeText: courses.nearMeFilterText,
        headlineText: courses.categoryLink.text,
      },
    },
  }
}

// static DailyList(name, props) {
//   const {
//     showSidebars: showSidebarsString,
//     showLoadMoreButton: showLoadMoreButtonString,
//     affiliates,
//     courses,
//     order,
//     qty,
//     ...rest
//   } = PropParser.format(props)

//   const showSidebars =
//     typeof showSidebarsString === 'undefined'
//       ? true
//       : showSidebarsString !== 'false'

//   const showLoadMoreButton =
//     typeof showLoadMoreButtonString === 'undefined'
//       ? true
//       : showLoadMoreButtonString !== 'false'

//   if (showSidebars) {
//     return [
//       {
//         name: 'DailyList',
//         props: {
//           ...rest,
//           affiliates: {
//             ...affiliates,
//           },
//           courses: {
//             ...courses,
//           },
//           perPage: qty,
//           sort: order,
//           showLoadMoreButton,
//         },
//       },
//     ]
//   } else {
//     return [
//       {
//         name: 'SimpleDailyList',
//         props: {
//           ...rest,
//           perPage: qty,
//           sort: order,
//           showLoadMoreButton,
//         },
//       },
//     ]
//   }
// }
